module.exports = __webpack_public_path__ + "img/mile1-m@1.421c848c.webp";